

export const isTicketAvailable = ({ status }: any) => {
  return Boolean(status === 'onSale');
};